import { createTheme } from '@mantine/core'

export const mantineTheme = createTheme({
  shadows: {
    xs: '0px 1px 2px rgba(16, 24, 40, 0.05)',
    sm: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
    md: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    lg: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
    xl: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
    xxl: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
    xxxl: '0px 32px 64px -12px rgba(16, 24, 40, 0.14)',
  },
  colors: {
    orange: [
      '#fff1e2',
      '#ffe2cc',
      '#ffc39a',
      '#ffa264',
      '#fe8737',
      '#fe751a',
      '#ff6600',
      '#e45a00',
      '#cb4f00',
      '#b14200',
    ],
    success: [
      '#E8F5E9',
      '#C8E6C9',
      '#A5D6A7',
      '#81C784',
      '#66BB6A',
      '#4CAF50',
      '#43A047',
      '#388E3C',
      '#2E7D32',
      '#1B5E20',
    ],
  },
  fontFamily: 'FigTree',
  fontSizes: {
    xs: '14px',
    sm: '16px',
    md: '18px',
    lg: '20px',
    xl: '22px',
    xxl: '24px',
  },
  headings: {
    sizes: {
      h1: {
        fontSize: '38px',
        lineHeight: '44px',
        fontWeight: '600',
      },
      h2: {
        fontSize: '30px',
        lineHeight: '36px',
        fontWeight: '600',
      },
      h3: {
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: '600',
      },
      h4: {
        fontSize: '20px',
        lineHeight: '26px',
        fontWeight: '600',
      },
      h5: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: '600',
      },
      h6: {
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: '600',
      },
    },
  },
  primaryColor: 'orange',
  components: {
    NumberInput: {
      defaultProps: {
        thousandSeparator: ',',
      },
    },
    NumberFormatter: {
      defaultProps: {
        thousandSeparator: true,
      },
    },
    LoadingOverlay: {
      defaultProps: {
        zIndex: 200,
      },
    },
    DateInput: {
      defaultProps: {
        firstDayOfWeek: 0,
      },
    },
    Drawer: {
      defaultProps: {
        closeOnEscape: false,
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        closeOnClickOutside: false,
        closeOnEscape: false,
        closeButtonProps: { style: { marginRight: 10 } },
        radius: 'lg',
        styles: {
          body: {
            paddingLeft: 26,
            paddingRight: 26,
            paddingBottom: 26,
          },
          title: {
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
      },
    },
  },
})
